export default (params) => ({
	init(){
		this.removeAll()
		if(!params){
			setTimeout(() => {
				window.location.href = '/'
			}, 5000);
		}
	},
	removeAll(){
		Object.values(this.$store.cart.items).forEach(item => item.count = 0);
		localStorage.removeItem("cart-details");
	},
})